import config from "./appconf";

type KickButtonProps = {
  id: string;
};

function KickButton({ id }: KickButtonProps) {
  const handleClick = () => {
    fetch(`${config.baseUrl}/api/v1/kick`, {
      method: "POST",
      mode: "cors",
      credentials: "include",
      body: `{"id":"${id}"}`,
      headers: {
        "Content-Type": "application/json",
      },
    }).then((res) => {
      console.log(`tried to kick and got a response of ${res.status}`);
    });
  };
  return (
    <button className="kickButton actionButton" onClick={handleClick}>
      kick
    </button>
  );
}

export default KickButton;
